import React, { useState } from "react";
import InterestedPartiesDialog from "./dialogs/InterestedParties";

export default function InterestedPartiesDialogEntry({ open, party, onOpenChange, onSave, isReadOnly = false }: {
  open: boolean;
  party: any;
  onOpenChange: (open: boolean) => void;
  onSave: (party: any) => void;
  isReadOnly?: boolean;
}) {
  return (
    <InterestedPartiesDialog
      open={open}
      party={party}
      onOpenChange={onOpenChange}
      onSave={onSave}
      isReadOnly={isReadOnly}
    />
  );
}
